import React, { PureComponent } from 'react';
import { setTitle } from '../../lib/utils/windowutils';
import qs from 'qs';
import Sites from '../../lib/models/sites/sites';
import PropTypes from 'prop-types';
import Octicon, { Plus, Search, Trashcan } from '@githubprimer/octicons-react';
import { handleOnKeyDown } from '../../lib/utils/commonutils';
import { Link } from 'react-router-dom';

class Site extends PureComponent {
  static propTypes = {
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  };

  state = {
    sites: { rows: [] },
    searchString: ''
  };

  render() {
    const { match, history } = this.props;
    const { sites, searchString } = this.state;
    const { offset } = this.getQueryParameters();
    return (
      <div>
        <div className="my-3 row">
          <div className="col-12 col-md-4 col-lg-3">
            <div className="input-group mb-3">
              <div className="input-group-prepend">
                <span className="input-group-text" onClick={this.handleSearch}>
                  <Octicon icon={Search} size="small" />
                </span>
              </div>
              <input
                type="text"
                value={searchString}
                onChange={e => this.setState({ searchString: e.target.value })}
                onKeyDown={e => handleOnKeyDown(e, this.handleSearch)}
                className="form-control form-control-sm"
                placeholder="Search"
              />
              <div className="input-group-append">
                <button
                  disabled={searchString === ''}
                  className="btn btn-sm btn-outline-danger"
                  onClick={e => history.push(match.url)}
                >
                  <Octicon icon={Trashcan} size="small" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <h5 className="mt-3">Sites</h5>
        {sites.rows.length > 0 && (
          <table className="table table-striped table-hover">
            <thead>
              <tr>
                <th>#</th>
                <th>Code</th>
                <th>Description</th>
                <th>Customer</th>
                <th>Distributor</th>
              </tr>
            </thead>
            <tbody>
              {sites.rows.map((site, i) => {
                return (
                  <tr key={i}>
                    <td>
                      <Link to={`${match.path}/${site.id}`}>#{site.id}</Link>
                    </td>
                    <td>{site.code}</td>
                    <td>{site.description}</td>
                    <td>
                      <Link to={`${match.path}?q=customer:${site.customer_code}`}>{site.customer_code}</Link>
                    </td>
                    <td>
                      <Link to={`${match.path}?q=distributor:${site.distributor_code}`}>{site.distributor_code}</Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
        {sites.rows.length === 0 && <div className="alert alert-info">No entity found</div>}
        <div className="d-flex bd-highlight mb-3">
          <div className="mt-3">
            <Link className="btn btn-info" to={`${match.path}/create`} title="Add new entity">
              <Octicon icon={Plus} />
            </Link>
          </div>
          {(Number(offset) || sites.hasMore) && (
            <div className="mt-3 ml-auto p-2 bd-highlight">
              <nav aria-label="Page navigation example">
                <ul className="pagination">
                  <li className={'page-item' + (!Number(this.getQueryParameters().offset) ? ' disabled' : '')}>
                    <Link to={this.getPaginationUrl('p')} className="page-link" onClick={e => e.target.blur()}>
                      Previous
                    </Link>
                  </li>
                  <li className={'page-item' + (sites.hasMore === false ? ' disabled' : '')}>
                    <Link to={this.getPaginationUrl('n')} className="page-link" onClick={e => e.target.blur()}>
                      Next
                    </Link>
                  </li>
                </ul>
              </nav>
            </div>
          )}
        </div>
      </div>
    );
  }

  componentDidMount() {
    setTitle('Sites');
    this.loadSites();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.location.search !== this.props.location.search) {
      this.loadSites();
    }
  }

  loadSites = () => {
    const { search } = this.props.location;
    const parameters = qs.parse(search, { ignoreQueryPrefix: true });
    const { limit, offset, order_by, sort, q } = parameters;

    let searchString = '';
    if (q) {
      searchString = q;
    }
    /*
        q.split(' ').forEach(search => {
          if (search.indexOf(':') < 0) {
            searchString += search;
          } else {

          }
        });
      }
       */
    if (this.state.searchString !== searchString) {
      this.setState({ searchString });
    }

    Sites.find({ limit, offset, order_by, sort, search: q }).then(sites => {
      this.setState({ sites });
    });
  };

  handleSearch = () => {
    const { pathname, search } = this.props.location;
    const parameters = qs.parse(search, { ignoreQueryPrefix: true });
    parameters.q = this.state.searchString;
    parameters.offset = 0;
    this.props.history.push(pathname + qs.stringify(parameters, { addQueryPrefix: true }));
  };

  getQueryParameters = () => {
    const { search } = this.props.location;
    return qs.parse(search, { ignoreQueryPrefix: true });
  };

  getPaginationUrl = direction => {
    const { pathname } = this.props.location;
    const parameters = this.getQueryParameters();
    let offset = Number(parameters.offset) || 0;
    let limit = Number(parameters.limit) || 10;
    let offsetPrev = offset - limit;
    let offsetNext = offset + limit;
    if (offsetPrev < 0) {
      offsetPrev = 0;
    }
    parameters.offset = direction === 'p' ? offsetPrev : offsetNext;
    return pathname + qs.stringify(parameters, { addQueryPrefix: true });
  };
}

export default Site;
